import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconMailEmailLetter5 = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: strokeWidth,
    stroke: color,
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13.758v-7.725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.028 18h-8.028c-1.657 0-3-1.343-3-3v-8.967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.136 11.018l-6.051-3.187c-.667-.352-1.085-1.044-1.085-1.798v-.033c0-1.105.895-2 2-2h13.967c1.123 0 2.033.91 2.033 2.033v.02c0 .742-.411 1.424-1.068 1.77l-6.068 3.196c-1.167.614-2.561.614-3.728-.001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 16.652l-2.188 2.188 -1.312-1.313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.682 14.322c1.757 1.762 1.757 4.62.001 6.383 -1.72 1.726-4.645 1.726-6.366 0 -1.757-1.763-1.756-4.621.001-6.383 1.757-1.763 4.607-1.763 6.364-1.77636e-15"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24h-24v-24Z"
  }));
};
//# sourceMappingURL=IconMailEmailLetter5.js.map